import(/* webpackMode: "eager" */ "/app/src/app/(authenticated)/layout.tsx");
